import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * Chart.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class PartnerRole extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, partnerId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][Partner] organizationId is mandatory');
        }
        if (!partnerId) {
            throw new ArgumentError('[Model][Partner] partnerId is mandatory');
        }
        return `/ticket/organizations/${organizationId}/partners/${partnerId}/roles`;
    }
}
